import moment from 'moment'
//noinspection ES6UnusedImports,Eslint
import de from 'moment/locale/de' //eslint-disable-line
//noinspection ES6UnusedImports,Eslint
import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

class ReduxFormDatePicker extends React.PureComponent {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  componentWillMount() {
    const { input } = this.props
    let value = moment(input.value)
    if (!value.isValid()) {
      input.onChange(moment().format())
    }
  }

  onChange(date) {
    const { input, endOfDay } = this.props
    if (endOfDay) {
      input.onChange(date.endOf('day').format())
    } else {
      input.onChange(date.format())
    }
  }

  render() {
    //eslint-disable-next-line
    const { input, meta, label, endOfDay, ...remainingParameters } = this.props
    // if value invalid, put to current time
    let date = moment(input.value)
    if (!date.isValid()) {
      date = moment()
    }
    return (
      <div className="field">
        {label && <label children={label} />}
        <DatePicker
          selected={date}
          onChange={this.onChange}
          locale="de"
          {...remainingParameters}
        />
      </div>
    )
  }
}

export default ReduxFormDatePicker



// WEBPACK FOOTER //
// ./src/components/shared/Forms/ReduxFormDatePicker.jsx